import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FlightZoneCapabilitiesState } from "@dtm-frontend/dss-shared-lib";
import { CesiumMapService, ContextMenuService, DTM_CESIUM_MAP_PROVIDERS } from "@dtm-frontend/shared/map/cesium";
import { RxjsUtils } from "@dtm-frontend/shared/utils";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Store } from "@ngxs/store";
import turfBbox from "@turf/bbox";
import { Camera, Rectangle } from "cesium";
import { first } from "rxjs/operators";

@UntilDestroy()
@Component({
    selector: "dss-admin-lib-dashboard",
    templateUrl: "./dashboard.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DTM_CESIUM_MAP_PROVIDERS, ContextMenuService],
})
export class DashboardComponent {
    protected readonly capabilities$ = this.store.select(FlightZoneCapabilitiesState.capabilities);

    constructor(private readonly store: Store, private readonly cesiumService: CesiumMapService) {
        this.setInitialViewboxObservable();
    }

    private setInitialViewboxObservable() {
        this.capabilities$.pipe(RxjsUtils.filterFalsy(), first(), untilDestroyed(this)).subscribe((capabilities) => {
            const viewbox = capabilities.preferences.initialViewbox;
            const bbox = turfBbox(viewbox);

            Camera.DEFAULT_VIEW_FACTOR = 0;
            Camera.DEFAULT_VIEW_RECTANGLE = Rectangle.fromDegrees(...bbox);

            this.cesiumService.getViewer().camera.flyTo({ destination: Camera.DEFAULT_VIEW_RECTANGLE, duration: 0 });
        });
    }
}
